import React, { useEffect, useRef } from 'react';

// Invisible marker that fires onVisible when scrolled into view.
// Used for infinite scroll — parent decides whether more data exists.
export const ScrollSentinel = ({ onVisible, disabled = false, testid = 'scroll-sentinel' }) => {
  const ref = useRef(null);
  const cbRef = useRef(onVisible);
  cbRef.current = onVisible;

  useEffect(() => {
    if (disabled) return undefined;
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    // Observe against the nearest scrollable ancestor (e.g. a max-h list),
    // falling back to the viewport for normal page-scrolled lists.
    let root = null;
    let p = el.parentElement;
    while (p) {
      const oy = getComputedStyle(p).overflowY;
      if (oy === 'auto' || oy === 'scroll') { root = p; break; }
      p = p.parentElement;
    }
    const obs = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) cbRef.current(); },
      { root, rootMargin: '300px' },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [disabled]);

  return <div ref={ref} className="h-px w-full" data-testid={testid} />;
};

export default ScrollSentinel;
